import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AnimationController, Animation, Gesture, GestureController } from '@ionic/angular';
import { GUIService } from '../../gui.service';

@Component({
  selector: 'app-calculator',
  templateUrl: './calculator.component.html',
  styleUrls: ['./calculator.component.scss'],
})
export class CalculatorComponent implements OnInit {

  @ViewChild('calculator', {static: true})
  calculator: ElementRef;

  @ViewChild('dragger', {static: true})
  dragger: ElementRef;

  private gesture?: Gesture;

  _values: {
    currentValue: string,
    previousValue: string,
    lastOpTemp: string,
    lastOp: string,
  } = {
    currentValue: undefined,
    previousValue: undefined,
    lastOp: '',
    lastOpTemp: '',
  }

  _status = {
    sum: false,
    multiply: false,
    subtract: false,
    divide: false,
  }

  _flags = {
    clearInput: false
  }

  _niceOperators = {
    sum: '+',
    subtract: '−',
    divide: '÷',
    multiply: '×',
  }

  constructor(
    private gestureCtrl: GestureController,
    public guiSvc: GUIService
  ) { }

  ngOnInit() {
    this.gesture = this.gestureCtrl.create({
      el: this.dragger.nativeElement,
      threshold: 10,
      gestureName: 'calculator-drag',
      onMove: (ev) => { this.onMove(ev) },
      onEnd:(ev) => { this.onEnd(ev) },
    })

    this.gesture.enable(true);
    this.onMove({deltaX: 0, deltaY: 0})
  }

  private onMove(ev) {
    const newPos = { x: this.guiSvc.calculatorLastPos.x + ev.deltaX, y: this.guiSvc.calculatorLastPos.y + ev.deltaY, }
    this.calculator.nativeElement.style.setProperty('transform', `translate3d(${newPos.x}px, ${newPos.y}px, 0)`)
  }

  private onEnd(ev) {
    const newPos = { x: this.guiSvc.calculatorLastPos.x + ev.deltaX, y: this.guiSvc.calculatorLastPos.y + ev.deltaY, }
    this.guiSvc.calculatorLastPos.x = newPos.x;
    this.guiSvc.calculatorLastPos.y = newPos.y;
  }

  onClear() {
    this._status = {
      sum: false,
      multiply: false,
      subtract: false,
      divide: false,
    }
    this._flags.clearInput = false;
    this._values = {
      currentValue: undefined,
      previousValue: undefined,
      lastOp: '',
      lastOpTemp: ''
    }
  }

  addToInput(val) {
    if (this._flags.clearInput) {
      this._values.previousValue = this._values.currentValue;
      this._values.currentValue = undefined;
      this._flags.clearInput = false;
    }

    if (val === 'comma') {
      if (!this._values.currentValue.includes('.')) {
        this._values.currentValue = `${this._values.currentValue ? this._values.currentValue : ''}.`;
      }
    } else {
      this._values.currentValue = `${this._values.currentValue ? this._values.currentValue : ''}${val}`;
    }
  }

  onToggle(fn: string) {
    if (this._values.currentValue) {
      if (this._values.previousValue) {
        if (this._status.sum && fn !== 'sum') {
          this.onResult();
        }
        if (this._status.subtract && fn !== 'subtract') {
          this.onResult();
        }
        if (this._status.multiply && fn !== 'multiply') {
          this.onResult();
        }
        if (this._status.divide && fn !== 'divide') {
          this.onResult();
        }
      }

      for (const fnKey of Object.keys(this._status)) {
        if (fnKey !== fn) {
          this._status[fnKey] = false;
        }
      }

      this._status[fn] = !this._status[fn];
      this._flags.clearInput = this._status[fn];
      this._values.lastOpTemp = `${this._values.currentValue}${this._status[fn] ? ` ${this._niceOperators[fn]} ` : ''}`
    }
  }

  onResult() {
    let tempResult = null;

    if (this._status.sum) {
      this.updateLastOP()
      tempResult = parseFloat(this._values.previousValue) + parseFloat(this._values.currentValue);
      this._status.sum = false;
    }
    if (this._status.subtract) {
      this.updateLastOP()
      tempResult = parseFloat(this._values.previousValue) - parseFloat(this._values.currentValue);
      this._status.subtract = false;
    }
    if (this._status.multiply) {
      this.updateLastOP()
      tempResult = parseFloat(this._values.previousValue) * parseFloat(this._values.currentValue);
      this._status.multiply = false;
    }
    if (this._status.divide) {
      this.updateLastOP()
      tempResult = parseFloat(this._values.previousValue) / parseFloat(this._values.currentValue);
      this._status.divide = false;
    }

    if (tempResult) {
      this._values.currentValue = `${Math.round((tempResult + Number.EPSILON) * 100) / 100}`;
      this._flags.clearInput = true;
    }
  }

  updateLastOP() {
    this._values.lastOpTemp = `${this._values.lastOpTemp} ${this._values.currentValue}`;
    this._values.lastOp = this._values.lastOpTemp;
    this._values.lastOpTemp = ``;
  }

}
